@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.product-activity {
  padding: 10px 20px;
}

.activity-container {
  display: flex;
  justify-content: space-between;
  color: @product-page--activity-container--text-color;
}

.activity-time,
.activity-user {
  font-size: 12px;
  font-weight: 500;
}

.activity-message {
  font-size: 13px;
  color: @product-page--activity-message--text-color;
  margin-top: 5px;
}

.activity-icon {
  height: 10px;
  width: 10px;
  margin-right: 5px;
  transform: scale(1.4);
}

.load-more {
  font-size: 14px;
  width: fit-content;
  min-width: 70px;
  height: 20px;
}

.content {
  height: 100%;
}
